import { render, staticRenderFns } from "./NorticBadge.vue?vue&type=template&id=e4ef500a&scoped=true&"
import script from "./NorticBadge.vue?vue&type=script&lang=js&"
export * from "./NorticBadge.vue?vue&type=script&lang=js&"
import style0 from "./NorticBadge.vue?vue&type=style&index=0&id=e4ef500a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ef500a",
  null
  
)

export default component.exports